import { useAtomsDevtools } from 'jotai-devtools/utils';

const JotaiDevTools = () => {
    useAtomsDevtools('RTB Webapp');
    return null;
};

export default JotaiDevTools;
